(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('FinanziamentoDetailController', FinanziamentoDetailController);

    FinanziamentoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Finanziamento', 'Gae', 'Utente', 'Progetto'];

    function FinanziamentoDetailController($scope, $rootScope, $stateParams, previousState, entity, Finanziamento, Gae, Utente, Progetto) {
        var vm = this;

        vm.finanziamento = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:finanziamentoUpdate', function(event, result) {
            vm.finanziamento = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
